export const KEY_VALUES = {
  UP: 38,
  DOWN: 40,
};
